var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:_vm.modalRef,attrs:{"hide-footer":"","title":'Éditer l\'étape ' + _vm.etape.nom,"size":"lg"},on:{"hidden":_vm.destroyModal}},[_c('edit-etape-evenement',{attrs:{"evenement":_vm.evenement,"etape":_vm.etape,"callback":_vm.callback}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }